import { render, staticRenderFns } from "./tree-item.vue?vue&type=template&id=2679bc88&scoped=true"
import script from "./tree-item.vue?vue&type=script&lang=js"
export * from "./tree-item.vue?vue&type=script&lang=js"
import style0 from "./tree-item.vue?vue&type=style&index=0&id=2679bc88&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2679bc88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2679bc88')) {
      api.createRecord('2679bc88', component.options)
    } else {
      api.reload('2679bc88', component.options)
    }
    module.hot.accept("./tree-item.vue?vue&type=template&id=2679bc88&scoped=true", function () {
      api.rerender('2679bc88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/matter-logs/tree-item.vue"
export default component.exports